import React from 'react';
import ContentBadge from './ContentBadge';
import { H1 } from '../text';

interface IPageHeaderProps {
	title: string;
	description: string;
	badge?: string | null;
	className?: string;
}

export const PageHeader: React.FC<IPageHeaderProps> = ({ title, description, badge, className = '' }) => {
	return (
		<header className={`bg-red-500 text-white py-16 ${className}`}>
			<div className="container mx-auto px-4 py-6 flex flex-col text-center justify-center items-center max-w-7xl">
				{badge && (
					<div className="mb-4">
						<ContentBadge text={badge} variant="primary" />
					</div>
				)}
				<H1 className="text-white mb-2">{title}</H1>
				<div
					className="text-2xl text-white/90 max-w-3xl prose prose-invert prose-lg"
					dangerouslySetInnerHTML={{ __html: description }}
				/>
			</div>
		</header>
	);
};

export default PageHeader;
